import React from "react";
import "./style.css";

export const TermsOfUse = ({}) => {
    return (
        <div className={'privacy-main-content'}>
            <div>Last updated: 22 October 2024</div>
            <h2><strong>Terms of Use</strong></h2>
            <ol type="1">
                <li>
                    <strong>Introduction.</strong> Welcome to the Calo application and any
                    other products or services owned or operated by Next Vision Limited
                    (“<strong><em>Company</em></strong>” or “<strong><em>Next Vision</em></strong>” or “<strong><em>we</em></strong>”
                    or “<strong><em>us</em></strong>” or “<strong><em>our</em></strong>”) (collectively, the “<strong><em>Next Vision
                    Service</em></strong>”). To access the Next Vision Service, you must at all times agree to
                    and abide by these terms of use, including any additional guidelines,
                    and any future modifications (collectively, these “<strong><em>Terms</em></strong>”). These Terms are a legal
                    contract between you, a user of at least 18
                    years of age (“<strong><em>you</em></strong>” or “<strong><em>User</em></strong>”), and Next Vision regarding your
                    use of the Next Vision Services.
                </li>
                <p>
                    By accessing, installing, browsing, using or subscribing to, or
                    registering for the Next Vision Service (including any content created,
                    uploaded, downloaded, copied, published, and propagated during the use of
                    the Next Vision Service), you acknowledge that you have read, understood,
                    and agree to be bound by these Terms. If at any time you do not agree to
                    these Terms, please terminate your use of the Next Vision Service.
                </p>
                <p>
                    Although Next Vision Service is always striving to improve itself, it is
                    not perfect. While Next Vision make reasonable efforts to ensure the
                    information provided is accurate, Next Vision cannot ensure the accuracy,
                    completeness and reliability of any and all information, data or content
                    on the Service. Therefore, You agree and understand that during Your use
                    of Next Vision Services, no content feedback can be used as any basis for
                    any civil or commercial activities performed by You and/or others,
                    otherwise all risks that may arise from such activities and all
                    responsibilities shall be borne by you, not by Next Vision. It’s essential
                    to remember that Next Vision is not a healthcare provider, and Next vision
                    Service is not a substitute for obtaining advice from a healthcare
                    professional. You should always consult a doctor or professional before
                    making any significant diet and fitness changes.
                </p>
                <li>
                    <strong>Authorized Users. Your access to and use of Next Vision Service is
                        subject to all applicable international, national, federal, state and
                        local laws and regulations. You represent and warrant that you will
                        not use Next Vision Service in any manner or for any purposes that are
                        unlawful or prohibited by these Terms. The Next Vision Service is not
                        for persons under the age of 18. If you are under 18 years of age,
                        then please do not use Next Vision Service.</strong>
                </li>
                <li>
                    <strong>Specific Features and Services.</strong> When using the Next
                    Vision Service, you may be subject to additional posted guidelines or
                    terms and conditions applicable to specific services and features which
                    may be posted from time to time (the “<strong><em>Guidelines</em></strong>”). All such Guidelines are hereby
                    incorporated by reference into the
                    Terms. In addition, your use of the Next Vision Service is governed by
                    the Next Vision privacy policy available <strong><em><a
                    href="https://app-service.foodscannerai.com/static/privacy_policy.html">here</a></em></strong>&nbsp;(the “<strong><em>Privacy
                    Policy</em></strong>”), which is hereby incorporated by reference into the Terms, and you
                    consent to the collection, use and disclosure of any personal
                    information provided by you to use in accordance with the Privacy
                    Policy.
                </li>
                <li>
                    <strong>Changes.</strong> Next Vision may revise this Terms from time to
                    time. Although Next Vision may include a notice on the home page of Next
                    Vision Service that the Terms has been modified, such notice may not
                    remain in place for any extended period of time. Accordingly, you should
                    review the Terms as posted on Next Vision Service from time to time.
                    Using Next Vision Service after any revised Terms has been posted will
                    constitute your acceptance of the revised Terms.
                </li>
                <li>
                    <strong>Limited License. Subject to the terms and conditions of these Terms,
                        Next Vision hereby grants you </strong>a limited, revocable, non-transferable, non-exclusive,
                    non-sublicensable license to use the Next Vision Services (and all
                    updates or upgrades provided) solely for private, non-commercial
                    purposes in accordance with these Terms.
                </li>
                <li>
                    <strong>Ownership; Proprietary Rights</strong>. The Next Vision Service
                    is owned and operated by Next Vision. The content, visual interfaces,
                    information, graphics, design, compilation, computer code, products,
                    software, algorithms, services, and all other elements of the Next
                    Vision Service that are provided by Next Vision (“<strong><em>Next Vision Materials</em></strong>”) are protected
                    by United States copyright, trade dress, patent, and
                    trademark laws, international conventions, and all other relevant
                    intellectual property and proprietary rights, and applicable laws. For
                    clarity, Next Vision Materials do not include any User Content (defined
                    below) or content from third party sites, whether Next Vision Service
                    provides a link to them or not. All Next Vision Materials contained on
                    Next Vision Service are the copyrighted property of Next Vision or
                    affiliated companies and/or third party licensors. All trademarks,
                    service marks, and trade names are proprietary to Next Vision
                    <a id="OLE_LINK9"></a><a id="OLE_LINK10"></a>or its affiliates and/or
                    third party licensors. Except as expressly authorized by Next Vision,
                    you agree not to sell, license, distribute, copy, modify, publicly
                    perform or display, transmit, publish, edit, adapt, decompile,
                    disassemble, reverse engineer, create derivative works from, or
                    otherwise make unauthorized use of Next Vision Materials.
                </li>
                <li>
                    <strong>Restrictions.</strong> As a condition of your use of the Next
                    Vision Service, you will not use Next Vision Service for any purpose
                    that is unlawful or prohibited by these Terms. Access to Next Vision
                    Materials and the Next Vision Service from territories where their
                    contents are illegal is strictly prohibited. Users are responsible for
                    complying with all local rules, laws, regulations and policies,
                    including, without limitation, rules about intellectual property rights,
                    the internet, technology, data, email, and/or privacy.
                </li>
                <p>
                    Any use by User of any of Next Vision Materials other than for private use
                    is prohibited.
                </p>
                <p>
                    You will not use the Next Vision Service in any manner that in our sole
                    discretion could damage, disable, overburden, or impair it or interfere
                    with any other party’s use of the Next Vision Service. You will not take
                    any action that imposes an unreasonable or disproportionately large load
                    on Next Vision’s infrastructure. You will not intentionally interfere with
                    or damage the operation of the Next Vision Service or any user’s enjoyment
                    of it, by any means, including uploading or otherwise disseminating
                    viruses, worms, or other malicious code. You will not remove, circumvent,
                    disable, damage or otherwise interfere with any security-related features
                    of the Next Vision Service, features that prevent or restrict the use or
                    copying of any content accessible through the Next Vision Service, or
                    features that enforce limitations on the use of the Next Vision Service.
                    You will not attempt to gain unauthorized access to the Next Vision
                    Service, or any part of it, other accounts, computer systems or networks
                    connected to the Next Vision Service, or any part of it, through hacking,
                    password mining or any other means or interfere or attempt to interfere
                    with the proper working of the Next Vision Service or any activities
                    conducted on the Next Vision Service. You will not obtain or attempt to
                    obtain any materials or information through any means not intentionally
                    made available through the Next Vision Service. You agree neither to
                    modify the Next Vision Service in any manner or form, nor to use modified
                    versions of the Next Vision Service, including (without limitation) for
                    the purpose of obtaining unauthorized access to the Next Vision Service.
                </p>
                <p>
                    Next Vision Service may contain robot exclusion headers. You agree that
                    you will not use any robot, spider, scraper, or other automated means to
                    access the Next Vision Service for any purpose without our express written
                    permission or bypass our robot exclusion headers or other measures we may
                    use to prevent or restrict access to the Next Vision Service. You will not
                    utilize framing techniques to enclose any trademark, logo, or other Next
                    Vision Materials without our express written consent. You will not use any
                    meta tags or any other “hidden text” utilizing Next Vision’s name or
                    trademarks without our express written consent.
                </p>
                <p>
                    You will not deep-link to the Next Vision Service and will promptly remove
                    any links that Next Vision finds objectionable in its sole discretion. You
                    will not use any Next Vision logos, graphics, or trademarks as part of the
                    link without our express written consent.
                </p>
                <p>
                    You will not send junk mail to other users of the Next Vision Service,
                    including, but not limited to unsolicited advertising, promotional
                    materials or other solicitation material, bulk mailing of commercial
                    advertising, chain mail, informational announcements, charity requests,
                    and petitions for signatures.
                </p>
                <li>
                    <strong>Your Content. </strong>
                    <ol type="a">
                        <li>
                            <u>Prohibited Content</u>. You shall not use the Next Vision
                            Service to create, upload, download, copy, publish or propagate any images,
                            sounds, videos, data, text, information or any other materials or
                            content (collectively, “<strong><em>Content</em></strong>”) that: (a) violates any rule, law, regulation or
                            policy; (b)
                            harms national interests, endangers national security or divulges
                            national secrets; (c) incites ethnic or racial discrimination or
                            hatred; (d) undermines the social stability; (e) contains obscenity,
                            sexual connotation, pornography, gambling, violence, murder, or
                            terror; (f) insults or defames others or infringes others’ lawful
                            rights and interests; or (g) contains abusive or threatening
                            information.
                        </li>
                        <li>
                            <u>License to Your Content</u>. You hereby grant
                            Next Vision a worldwide, non-exclusive, irrevocable, royalty-free,
                            fully-paid, perpetual, sublicensable (through multiple tiers), fully
                            transferable license to <a id="OLE_LINK7"></a><a id="OLE_LINK8"></a>use, distribute, reproduce, create
                            derivative
                            works from, publish, translate, publicly perform and publicly
                            display any Content that you upload or publish to the Next Vision
                            Services (collectively, “<strong><em>Your Content</em></strong>”), in any format or medium now known or later
                            developed for any
                            purpose. Next Vision can use Your Content in the App and in Next
                            Vision’s other products or services, and can transfer the license or
                            authorization of using such information and content to its related
                            companies and cooperation partners with no need to obtain your
                            consent again. Next Vision reserves the right to display
                            advertisements and sponsorships in connection with Your Content.
                        </li>
                        <p>
                            Next Vision has the right to remove, at its sole discretion and without
                            notice to you, Your Content if it infringes others’ rights and interests.
                            Next Vision has the right to suspend or terminate access to the Next
                            Vision Service to any user who uses the Next Vision Service in violation
                            of copyright law or other intellectual property law. All liabilities for
                            damage for any claim for rights raised by the said third party shall be
                            assumed by you, not by Next Vision, and you shall compensate for all
                            losses and damages Next Vision incurs arising therefrom, including but not
                            limited to economic losses and business losses.
                        </p>
                        <li>
                            <u>Representation and Warranty</u>. You represent, warrant and
                            covenant that at all times: (i) the Your Content does not infringe
                            any third party’s intellectual property, right of reputation, right
                            of name, right of privacy, moral rights and other lawful rights and
                            interests; (ii) you own or have the necessary licenses, rights,
                            consents and permissions for your use of the Your Content in
                            connection with the Next Vision Services and Next Vision’s use of
                            the Your Content pursuant to Section 8(b).
                        </li>
                    </ol>
                </li>

                <li>
                    <strong>Identity Authentication</strong>. Next Vision uses many
                    techniques to identify you when you register for and/or access, browse,
                    use or subscribe to the Next Vision Service. This verification is only
                    an indication of increased likelihood that your identity is correct. You
                    authorize Next Vision, directly or through third parties, to make any
                    inquiries Next Vision considers necessary to validate your registration.
                </li>
                <li>
                    <strong>User Account Information</strong>. You agree that the
                    information you provide to Next Vision upon registration and, at all
                    other times, will be true, accurate, current, and complete. You also
                    agree that you will ensure that this information is kept accurate and
                    up-to-date at all times. When you register, you will be asked to provide
                    a password. As you will be responsible for all activities that occur
                    under your password, you should keep your password confidential. You are
                    solely responsible for maintaining the confidentiality of your account
                    and password and for restricting access to your computer, and you agree
                    to accept responsibility for all activities that occur under your
                    account or password. If you have reason to believe that your account is
                    no longer secure (for example, in the event of a loss, theft or
                    unauthorized disclosure or use of your account ID, password), you will
                    immediately notify Next Vision. You will be liable for the losses
                    incurred by Next Vision or others due to any unauthorized use of your
                    account.
                </li>
                <li>
                    <strong>Communications; Notice.</strong> Under these Terms, you consent
                    to receive communications from Next Vision electronically. We will
                    communicate with you by email or by posting notices on the Next Vision
                    Service. You agree that all agreements, notices, disclosures, and other
                    communications that we provide to you electronically satisfy any legal
                    requirement that such communications be in writing. Except as explicitly
                    stated otherwise, legal notices shall be served on Next Vision’s
                    national registered agent or to the email address you provide to Next
                    Vision during the registration process. Notice shall be deemed given 24
                    hours after email is sent, unless the sending party is notified that the
                    email address is invalid. Alternatively, we may give you legal notice by
                    mail to the address provided during the registration process. In such
                    case, notice shall be deemed given three days after the date of mailing.
                </li>
                <li>
                    <strong>Feedback.</strong> You may, but are not required to, provide
                    suggestions, comments, ideas, or know-how, in any form, to Next Vision
                    related to the Next Vision Services (“<strong><em>Feedback</em></strong>”). Any Feedback shall not be considered
                    your confidential information
                    and may be used by Next Vision for any purpose. There shall be no
                    obligation to provide compensation for use of Feedback.
                </li>
                <li>
                    <strong>Third Party Sites.</strong> The Next Vision Service may include
                    links to other websites or services solely as a convenience to users
                    (“<strong><em>Linked Sites</em></strong>”). Next Vision does not endorse any Linked Sites or the information,
                    material, products or services contained on Linked Sites or accessible
                    through Linked Sites. Furthermore, Next Vision makes no express or
                    implied warranties with regard to the information, material, products,
                    or services that are contained on or accessible through Linked Sites.
                    Access and use of linked sites, including the information, material,
                    products, and services on linked sites or available through linked
                    sites, is solely at your own risk.
                </li>
                <p>
                    Your correspondence or business dealings with, or participation in
                    promotions of, advertisers found on or through the Next Vision Service are
                    solely between you and such advertiser. You agree that Next Vision will
                    not be responsible or liable for any loss or damage of any sort incurred
                    as the result of any such dealings or as the result of the presence of
                    such advertisers on the Next Vision Service.
                </p>
                <p>
                    Next Vision may make changes to or discontinue any of the content or
                    services available on the Next Vision Service at any time, and without
                    notice. The content or services on the Next Vision Service may be out of
                    date, and Next Vision makes no commitment to update these materials.
                </p>
                <li>
                    <strong>User Content. </strong>You acknowledge and agree that: (a)
                    Content is provided to you AS IS and that Next Vision is not responsible
                    for examining or evaluating Content created, uploaded, publish or
                    propagate or otherwise made available by end users through the Next
                    Vision Services (“<strong><em>User Content</em></strong>”); (b) Next Vision does not guarantee accuracy of any
                    such User
                    Content or that such User Content will continue to be available; (c) by
                    using the Next Vision Services, you may encounter User Content that you
                    deem offensive, indecent, or objectionable and that such User Content
                    may not be labeled as such; and (d) Next Vision has no liability to you
                    for any such User Content.
                </li>
                <li>
                    <strong>Termination.</strong> You agree that Next Vision, in its sole
                    discretion and for any or no reason, may terminate any account (or any
                    part thereof) you may have with Next Vision. In addition, Next Vision
                    reserves the right to discontinue any aspect of the Next Vision Service
                    at any time, including the right to discontinue the display of any
                    licensed content, linked or embedded content, Your Content or Third
                    Party Content, either generally or in specific cases. For the avoidance
                    of doubt, Next Vision shall in no event be responsible for the deletion,
                    losing of, or failure to store Your Content. You agree that any
                    termination of your access to the Next Vision Service or any account you
                    may have or portion thereof may be affected without prior notice, and
                    you agree that Next Vision will not be liable to you or any third party
                    for such termination. Any suspected fraudulent, abusive, or illegal
                    activity that may be grounds for termination of your use of Next Vision
                    Service may be referred to appropriate law enforcement authorities.
                    These remedies are in addition to any other remedies Next Vision may
                    have at law or in equity.
                </li>
                <li>
                    <strong>DISCLAIMERS; NO WARRANTIES.</strong><a id="OLE_LINK1"></a><a id="OLE_LINK2"></a>&nbsp;WITHOUT LIMITING ANY
                    OTHER PROVISION OF THIS
                    SECTION AND IN ADDITION TO ALL OTHER PROVISIONS OF THIS SECTION, TO THE
                    FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEXT VISION EXPRESSLY
                    DISCLAIMS ALL WARRANTIES AND CONDITIONS OF ANY KIND, EITHER EXPRESS OR
                    IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OR
                    CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                    NON-INFRINGEMENT OF THIRD PARTY RIGHTS, AND THOSE ARISING FROM A COURSE
                    OF DEALING OR USAGE OF TRADE, WITH RESPECT TO NEXT VISION SERVICE. NEXT
                    VISION MAKES NO WARRANTY THAT NEXT VISION SERVICE WILL MEET YOUR
                    REQUIREMENTS, OR THAT NEXT VISION SERVICE WILL BE UNINTERRUPTED, TIMELY,
                    SECURE, OR ERROR FREE. NEXT VISION DOES NOT MAKE ANY WARRANTY OR
                    REPRESENTATION AS TO THE USE OR THE RESULTS THAT MAY BE OBTAINED FROM
                    THE USE OF NEXT VISION SERVICE. YOU ACKNOWLEDGE THAT NEXT VISION SERVICE
                    MAY BE SUBJECT TO OPERATING ERRORS OR DEFECTS INCLUDING, BUT NOT LIMITED
                    TO LOSS OF DATA, DELAYS, NON-DELIVERIES, ERRORS, SYSTEM DOWN TIME,
                    MISDELIVERIES, NETWORK OR SYSTEM OUTAGES, FILE CORRUPTION, OR SERVICE
                    INTERRUPTIONS. NO SUCH EVENT SHALL CONSTITUTE A BREACH OF THIS OR ANY
                    OTHER CONTRACT ON THE PART OF NEXT VISION, EVEN IF CAUSED BY THE
                    NEGLIGENCE OR GROSS NEGLIGENCE OF NEXT VISION OR ANY OF ITS AFFILIATES,
                    EMPLOYEES, AGENTS, LICENSORS OR SUBCONTRACTORS.
                </li>
                <p>
                    CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE
                    EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU,
                    SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY NOT
                    APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS.
                </p>
                <li>
                    <strong>Indemnification.</strong> <a id="OLE_LINK3"></a><a id="OLE_LINK4"></a>You agree to indemnify and hold Next
                    Vision, and
                    its affiliated companies, and its suppliers and partners, harmless from
                    any claims, losses, damages, liabilities, including attorney’s fees,
                    arising out of your use or misuse of the Next Vision Service, violation
                    of these Terms, violation of the rights of any other person or entity,
                    or any breach of the foregoing representations, warranties, and
                    covenants. Next Vision reserves the right, at our own expense, to assume
                    the exclusive defense and control of any matter for which you are
                    required to indemnify us and you agree to cooperate with our defense of
                    these claims.
                </li>
                <li>
                    <a id="OLE_LINK5"></a><a id="OLE_LINK6"></a><strong>LIMITATION OF LIABILITY.</strong>&nbsp;UNDER NO CIRCUMSTANCES,
                    INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE, SHALL NEXT VISION OR ITS
                    AFFILIATES, CONTRACTORS, EMPLOYEES, AGENTS, OR THIRD PARTY PARTNERS OR
                    SUPPLIERS, BE LIABLE TO YOU FOR ANY SPECIAL, INDIRECT, INCIDENTAL,
                    CONSEQUENTIAL, OR EXEMPLARY DAMAGES THAT RESULT FROM YOUR USE OR THE
                    INABILITY TO USE NEXT VISION MATERIALS ON NEXT VISION SERVICE, NEXT
                    VISION SERVICE ITSELF, OR ANY OTHER INTERACTIONS WITH NEXT VISION, EVEN
                    IF NEXT VISION OR A NEXT VISION AUTHORIZED REPRESENTATIVE HAS BEEN
                    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. APPLICABLE LAW MAY NOT ALLOW
                    THE LIMITATION OR EXCLUSION OF LIABILITY OR INCIDENTAL OR CONSEQUENTIAL
                    DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. IN
                    SUCH CASES, NEXT VISION’S LIABILITY WILL BE LIMITED TO THE EXTENT
                    PERMITTED BY LAW.
                </li>
                <p>
                    IN NO EVENT SHALL NEXT VISION’S OR ITS AFFILIATES, CONTRACTORS, EMPLOYEES,
                    AGENTS, OR THIRD PARTY PARTNERS OR SUPPLIERS' TOTAL LIABILITY TO YOU FOR
                    ALL DAMAGES, LOSSES, AND CAUSES OF ACTION ARISING OUT OF OR RELATING TO
                    THESE TERMS OR YOUR USE OF NEXT VISION SERVICE (WHETHER IN CONTRACT, TORT,
                    WARRANTY, OR OTHERWISE) EXCEED ONE HUNDRED DOLLARS.
                </p>
                <p>
                    THESE LIMITATIONS SHALL ALSO APPLY WITH RESPECT TO DAMAGES INCURRED BY
                    REASON OF ANY PRODUCTS OR SERVICES SOLD OR PROVIDED TO YOU BY THIRD
                    PARTIES OTHER THAN NEXT VISION AND RECEIVED BY YOU THROUGH OR ADVERTISED
                    ON THE NEXT VISION SERVICE OR RECEIVED BY YOU THROUGH ANY LINKS PROVIDED
                    ON THE NEXT VISION SERVICE.
                </p>
                <li>
                    <strong>Disputes and Arbitration.</strong>
                    <ol type="a">
                        <li>
                            <u>Disputes</u>. For all disputes arising out of or
                            relating in any way to the Next Vision Service, you must first send
                            a written description of your claim to Next Vision to allow us an
                            opportunity to resolve the dispute. You and Next Vision each agree
                            to negotiate your claim in good faith. If we still cannot resolve
                            the dispute you may request arbitration if your claim or dispute
                            cannot be resolved within 60 days.
                            <strong>Please read this section carefully. It affects your legal rights.
                                It provides for resolution of disputes through individual
                                arbitration instead of court trials and class actions. Arbitration
                                is more informal than a lawsuit in court, uses a neutral
                                arbitrator instead of a judge or jury, and discovery is more
                                limited. Arbitration is final and binding and subject to only very
                                limited review by a court. This arbitration clause shall survive
                                termination of the Terms.</strong>
                        </li>
                        <li>
                            <u>Governing Law</u>. By using the Next Vision
                            Service, you agree that the statutes and laws of the United States
                            without regard to conflicts of laws principles, will apply to all
                            matters relating to use of the Next Vision Service. If we are unable
                            to commence arbitration, you agree that any litigation shall be
                            subject to the exclusive jurisdiction of the state or federal courts
                            in New York, NY and shall be subject to the laws of New York without
                            giving effect to any principles of conflicts of law.
                        </li>
                        <li>
                            <u>Arbitration Procedures</u>.
                            <ol type="1">
                                <li>
                                    Any dispute, controversy or claim arising in any way out of or
                                    in connection with the Terms (including, without limitation: (1)
                                    any contractual, pre-contractual or non-contractual rights,
                                    obligations or liabilities; and (2) any issue as to the
                                    existence, validity or termination of the Terms) shall be
                                    referred to and finally resolved by binding arbitration
                                    administered by the International Centre for Dispute Resolution
                                    (“ICDR”) in accordance with its International Arbitration Rules
                                    in force as at the date of this Agreement (the “Rules”), which
                                    Rules are deemed to be incorporated by reference into this
                                    Section 19 and as may be amended by the rest of this Section 19.
                                </li>
                                <li>
                                    The arbitration tribunal (“Tribunal”) shall consist of three (3)
                                    arbitrators.&nbsp; The claimant shall designate one (1) arbitrator.&nbsp;
                                    The respondent shall designate one (1) arbitrator.&nbsp; The two
                                    arbitrators thus appointed shall designate the third arbitrator
                                    who shall be the presiding arbitrator.&nbsp; If within fourteen (14)
                                    days of a request from the other party to do so a party fails to
                                    designate an arbitrator, or if the two arbitrators fail to
                                    designate the third arbitrator within fourteen (14) days after
                                    the confirmation of appointment of the second arbitrator, the
                                    appointment shall be made, upon request of a party, by the ICDR
                                    in accordance with the Rules.
                                </li>
                                <li>
                                    The seat of the arbitration shall be New York, New York, U.S.A.
                                    The language of the arbitration shall be English. This
                                    arbitration clause shall be governed by the laws of the United
                                    States, including the Federal Arbitration Act, and to the extent
                                    not inconsistent therewith, the laws of the State of New York
                                    (United States).
                                </li>
                                <li>
                                    Any award of the Tribunal shall be made in writing and shall be
                                    final and binding on the parties from the day it is made.&nbsp; The
                                    parties undertake to carry out the award without delay. The
                                    arbitrator or arbitrators shall be empowered to award only those
                                    damages which are permitted by the Terms, subject to any
                                    disclaimers of damages and liability limits set forth in thee
                                    Terms, but the arbitrator or arbitrators shall not have the
                                    authority to reform, modify or materially change the Terms.&nbsp; The
                                    award rendered by the arbitrator(s) shall include costs of the
                                    arbitration, reasonable attorneys’ fees and reasonable costs for
                                    experts and other witnesses.&nbsp; Judgment on the award may be
                                    entered in any court having jurisdiction. The parties hereby
                                    irrevocably waive their right to any form of appeal, review or
                                    recourse to any court or other judicial authority insofar as
                                    such waiver may be validly made. The parties waive any right to
                                    apply to any court and/or other judicial authority to determine
                                    any preliminary point of law and/or review any question of law
                                    and/or the merits, insofar as such waiver may validly be made.&nbsp;
                                    The parties shall not be deemed, however, to have waived any
                                    other right to challenge any award.
                                </li>
                                <li>
                                    The parties agree that the arbitrator(s) shall have the
                                    authority to issue interim orders for provisional relief,
                                    including, but not limited to, orders for injunctive relief,
                                    attachment or other provisional remedy, as necessary to protect
                                    either party’s name, proprietary information, trade secrets,
                                    know-how or any other proprietary right.&nbsp; The parties agree that
                                    any interim order of the arbitrator(s) for any injunctive or
                                    other preliminary relief shall be enforceable in any court of
                                    competent jurisdiction.&nbsp; In addition, nothing in the Terms shall
                                    be deemed as preventing either party from seeking provisional
                                    relief from any court of competent jurisdiction, in order to
                                    protect that party’s name or proprietary rights.&nbsp; Nothing in
                                    this Section shall be construed as preventing any party from
                                    seeking conservatory or interim relief from any court of
                                    competent jurisdiction, including without limitation to protect
                                    either party’s name, proprietary information, trade secrets,
                                    know-how or any other proprietary rights.
                                </li>
                            </ol>
                        </li>
                    </ol>
                </li>
                <li>
                    <strong>Miscellaneous.</strong>
                    <ol type="a">
                        <li>
                            <u>Waiver</u>. A provision of these Terms may be
                            waived only by a written instrument executed by the party entitled
                            to the benefit of such provision. The failure of any party at any
                            time to require performance of any provision of these Terms shall in
                            no manner affect such party’s right at a later time to enforce the
                            same. A waiver of any breach of any provision of these Terms shall
                            not be construed as a continuing waiver of other breaches of the
                            same or other provisions of these Terms.
                        </li>
                        <li>
                            <u>Severability</u>. If any provision of these
                            Terms shall be unlawful, void, or for any reason unenforceable, then
                            that provision shall be deemed severable from these Terms and shall
                            not affect the validity and enforceability of any remaining
                            provisions.
                        </li>
                        <li>
                            <u>Assignment</u>. The Terms, and any rights and
                            licenses granted hereunder, may not be transferred or assigned by
                            you, but may be assigned by Next Vision without restriction.
                        </li>
                        <li>
                            <u>Survival</u>. Sections 6, 8(b), 10, 11, 13, 16,
                            17, 18, 19, and 20 will survive any termination of these Terms.
                        </li>
                        <li>
                            <u>Headings</u>. The heading references herein are
                            for convenience purposes only, do not constitute a part of these
                            Terms, and shall not be deemed to limit or affect any of the
                            provisions hereof.
                        </li>
                        <li>
                            <u>Entire Agreement</u>. These Terms are the entire
                            agreement between you and Next Vision relating to the subject matter
                            herein and shall not be modified except in writing, signed by both
                            parties, or by a change to these Terms made by Next Vision as set
                            forth in Section 4.
                        </li>
                        <li>
                            <u>CLAIMS</u>.&nbsp; YOU AND NEXT VISION AGREE THAT ANY
                            CAUSE OF ACTION ARISING OUT OF OR RELATED TO NEXT VISION SERVICE
                            MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES.
                            OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.
                        </li>
                        <li>
                            <u>End-User Terms Required by Apple</u>. If you have downloaded the
                            Next Vision Services mobile application (the “<strong><em>App</em></strong>”) from the Apple, Inc.
                            (“<strong><em>Apple</em></strong>”) App Store or if you are using the App on an iOS device, you
                            acknowledge that you have read, understood, and agree to the
                            following notice regarding Apple. These Terms are between you and
                            Next Vision only, not with Apple, and Apple is not responsible for
                            the Next Vision Service and the content thereof. Apple has no
                            obligation whatsoever to furnish any maintenance and support
                            services with respect to the App. In the event of any failure of the
                            App to conform to any applicable warranty, then you may notify Apple
                            and Apple will refund any applicable purchase price for the App to
                            you; and that, to the maximum extent permitted by applicable law,
                            Apple has no other warranty obligation whatsoever with respect to
                            the App. Apple is not responsible for addressing any claims by you
                            or any third party relating to the App or your possession and/or use
                            of the App, including: (a) product liability claims; (b) any claim
                            that the App fails to conform to any applicable legal or regulatory
                            requirement; and (c) claims arising under consumer protection or
                            similar legislation. Apple is not responsible for the investigation,
                            defense, settlement and discharge of any third party claim that the
                            App and/or your possession and use of the App infringe that third
                            party’s intellectual property rights. You agree to comply with any
                            applicable third party terms, when using the App. Apple, and Apple’s
                            subsidiaries, are third party beneficiaries of these Terms, and upon
                            your acceptance of these Terms, Apple will have the right (and will
                            be deemed to have accepted the right) to enforce these Terms against
                            you as a third party beneficiary of these Terms.
                        </li>
                        <li>
                            <u>Queries</u>. You may contact us at the address below with any
                            questions, complaints or claims regarding the Next Vision Services:
                        </li>
                        <p>Next Vision Limited</p>
                        <p>
                            RM D 10/F Tower A Billion CTR 1 Wang Kwong RD Kowloon Bay KL Hong Kong
                        </p>
                        <p>Email: website@caloapp.ai</p>
                        <li>
                            <u>DMCA/Copyright</u>. If you believe that anything on the Next
                            Vision Services infringes a copyright that you own or control, you
                            may file a notice with our designated agent:
                        </li>
                        <p>Next Vision Limited</p>
                        <p>Email: copyright@caloapp.ai</p>
                        <p>
                            If you file a notice with our designated agent, it must comply with the
                            requirements set forth at&nbsp;<a href="https://www.law.cornell.edu/uscode/text/17/512" target="_blank">17
                            U.S.C. § 512(c)(3)</a>. That means the notice must: (i) contain the physical or electronic
                            signature of a person authorized to act on behalf of the copyright owner;
                            (ii) identify the copyrighted work claimed to have been infringed; (iii)
                            identify the material that is claimed to be infringing or to be the
                            subject of infringing activity and that is to be removed, or access to
                            which is to be disabled, and information reasonably sufficient to let us
                            locate the material; (iv) provide your contact information, including your
                            address, telephone number, and an email address; (v) provide a personal
                            statement that you have a good-faith belief that the use of the material
                            in the manner complained of is not authorized by the copyright owner, its
                            agent, or the law; (vi) provide a statement that the information in the
                            notification is accurate and, under penalty of perjury, that you are
                            authorized to act on behalf of the copyright owner.
                        </p>
                    </ol>
                </li>
            </ol>
        </div>
    );
};
